export const LANGUAGES = {
    ENGLISH: 'eng',
    SPANISH: 'spa',
};

export const DICTIONARY_KEYS = {
    VOCABULARY: 'Vocabulary',
    START: 'Start',
    RESUME: 'Resume',
    DONE: 'Done',
    OK: 'OK',
    YES: 'Yes',
    NO: 'No',
    ALL_FORMS_COMPLETED: 'All-forms-completed',
};
